{
  "apiVersion": "1",
  "context": "",
  "id": "",
  "method": "Folders->GET",
  "data": {
    "items": [
      {
        "id": 1,
        "name": "Прocроченные",
        "status": "pin",
        "count": 2,
        "params": "period_alias=previousMonth&status=opened",
        "icon": "assignment_late",
        "order": 1,
        "colorBadge": "red"
      },
      {
        "id": 2,
        "name": "Активные",
        "status": "pin",
        "count": 0,
        "params": "period_alias=nextThreeDays&status=opened",
        "icon": "access_alarm",
        "order": 2,
        "colorBadge": "blue"
      },
      {
        "id": 3,
        "name": "Выполненные",
        "status": "pin",
        "count": 17,
        "params": "status=completed",
        "icon": "done_all",
        "order": 3,
        "colorBadge": "green"
      },
      {
        "id": 4,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 1,
        "colorBadge": "orange"
      },
      {
        "id": 5,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 12,
        "colorBadge": "orange"
      },
      {
        "id": 6,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 3,
        "colorBadge": "orange"
      },
      {
        "id": 7,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 4,
        "colorBadge": "orange"
      },
      {
        "id": 8,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 5,
        "colorBadge": "orange"
      },
      {
        "id": 9,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 6,
        "colorBadge": "orange"
      },
      {
        "id": 14,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 14,
        "colorBadge": "orange"
      },
      {
        "id": 45,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 45,
        "colorBadge": "orange"
      },
      {
        "id": 46,
        "name": "Назначенные мне",
        "status": "normal",
        "count": 11,
        "params": "assignees=YSHEGLOV",
        "icon": null,
        "order": 46,
        "colorBadge": "orange"
      }
    ]
  }
}